/** Placement UI permissions — single source of truth for routes, nav, and in-page gates. */

export function canViewPlacementOverview(user) {
  const role = user?.role;
  return role === 'admin' || role === 'cbcfaculty';
}

export function canManageMockCampaigns(user) {
  const role = user?.role;
  return role === 'admin' || role === 'cbcfaculty';
}

export function canConductMockInterview(user) {
  const role = user?.role;
  return role === 'faculty' || role === 'cbcfaculty' || role === 'admin';
}

export function canViewCoachingInsights(user) {
  const role = user?.role;
  return role === 'admin' || role === 'cbcfaculty';
}

/** Students needing coaching support (career intelligence attention list). */
export function canViewCoachingStudents(user) {
  const role = user?.role;
  return role === 'admin' || role === 'faculty' || role === 'cbcfaculty';
}

/** Faculty/CBC batch placement analytics dashboard. */
export function canViewPlacementBatchAnalytics(user) {
  const role = user?.role;
  return role === 'admin' || role === 'cbcfaculty' || role === 'faculty';
}

/**
 * Company intelligence curation console (Phase 7).
 * Mirrors backend CURATE_COMPANY_INTEL: admin + cbcfaculty only.
 * faculty and student are explicitly forbidden.
 */
export function canCurateCompanyIntel(user) {
  const role = user?.role;
  return role === 'admin' || role === 'cbcfaculty';
}

export function isStudentPlacementUser(user) {
  return user?.role === 'student';
}

/** @deprecated Use canConductMockInterview */
export function canEvaluateInterviews(user) {
  return canConductMockInterview(user);
}

/** @deprecated Use canViewCoachingInsights */
export function canViewCareerOverview(user) {
  return canViewCoachingInsights(user);
}

/** @deprecated Use canViewCoachingStudents */
export function canViewCareerAttention(user) {
  return canViewCoachingStudents(user);
}
